/**
 * Category Layout registry — Elementor-style layout modes for category /
 * product-row / product-grid sections in the Visual Builder.
 *
 * The consumer's rendering code branches on `layout` to pick the correct
 * container (grid / horizontal scroll / vertical stack / slider carousel).
 * Cols per breakpoint are honoured for the "grid" and "auto" modes.
 *
 * Backward compat: legacy consumers that don't recognise a layout key
 * fall back to their existing render — nothing breaks.
 */

export const CATEGORY_LAYOUTS = [
  {
    value: "auto",
    label: "Auto",
    icon: "LayoutTemplate",
    hint: "Picks Grid on desktop, Horizontal on mobile.",
  },
  {
    value: "grid",
    label: "Grid",
    icon: "LayoutGrid",
    hint: "Responsive N-column grid.",
  },
  {
    value: "horizontal",
    label: "Horizontal",
    icon: "MoveHorizontal",
    hint: "Single-row horizontal scroll.",
  },
  {
    value: "vertical",
    label: "Vertical",
    icon: "AlignVerticalJustifyCenter",
    hint: "Stacked single-column list.",
  },
  {
    value: "slider",
    label: "Slider",
    icon: "Images",
    hint: "Paged slider with dots · manual advance.",
  },
  {
    value: "auto_carousel",
    label: "Auto Carousel",
    icon: "GalleryHorizontal",
    hint: "Auto-advancing carousel with configurable interval.",
  },
];

export const LAYOUT_DEFAULTS = {
  layout: "auto",
  desktop_cols: 6,
  tablet_cols: 4,
  mobile_cols: 3,
  gap: 12,
  autoplay: false,
  autoplay_interval: 3500,
  show_arrows: true,
  show_dots: true,
};

/** Fields shown in the CategoryLayoutEditor. */
export const CATEGORY_LAYOUT_FIELDS = [
  { key: "desktop_cols",      label: "Desktop Columns",   type: "number", min: 1,   max: 12,   step: 1 },
  { key: "tablet_cols",       label: "Tablet Columns",    type: "number", min: 1,   max: 10,   step: 1 },
  { key: "mobile_cols",       label: "Mobile Columns",    type: "number", min: 1,   max: 6,    step: 1 },
  { key: "gap",               label: "Gap (px)",          type: "number", min: 0,   max: 48,   step: 2 },
  { key: "autoplay",          label: "Autoplay",          type: "toggle", showIfLayout: ["slider", "auto_carousel"] },
  { key: "autoplay_interval", label: "Interval (ms)",     type: "number", min: 1000, max: 12000, step: 250, showIfLayout: ["slider", "auto_carousel"] },
  { key: "show_arrows",       label: "Show Arrows",       type: "toggle", showIfLayout: ["slider", "auto_carousel", "horizontal"] },
  { key: "show_dots",         label: "Show Dots",         type: "toggle", showIfLayout: ["slider", "auto_carousel"] },
];
